import { ApiError } from './api';

export interface PrereqInfo {
  title: string;
  message: string;
  to: string;
  linkLabel: string;
}

/** Map a 412 prerequisite_missing error to a helpful "what to set up" link. */
export function prerequisiteInfo(err: unknown): PrereqInfo | null {
  if (!(err instanceof ApiError) || !err.isPrerequisite) return null;
  const d = (err.details ?? {}) as { settingsPath?: string; setup?: string; prerequisite?: string };
  const hint = `${d.setup ?? d.prerequisite ?? ''} ${err.message}`.toLowerCase();
  let to = d.settingsPath ?? '/settings';
  let linkLabel = 'Open settings';
  if (!d.settingsPath) {
    if (/consent/.test(hint)) [to, linkLabel] = ['/settings/ai', 'Review AI consent'];
    else if (/ai|provider|model|budget|api key/.test(hint)) [to, linkLabel] = ['/settings/ai', 'Set up an AI provider'];
    else if (/mailbox|account|reconnect|oauth|imap/.test(hint)) [to, linkLabel] = ['/settings/accounts', 'Manage email accounts'];
    else if (/signature/.test(hint)) [to, linkLabel] = ['/settings/signatures', 'Edit signatures'];
    else if (/library|attachment|file/.test(hint)) [to, linkLabel] = ['/library', 'Open Attachment Library'];
    else if (/ring|notification|sound/.test(hint)) [to, linkLabel] = ['/settings/notifications', 'Notification settings'];
    else if (/rule|responder|pause/.test(hint)) [to, linkLabel] = ['/settings/responders', 'Responder settings'];
  }
  return { title: 'Setup needed', message: err.message, to, linkLabel };
}
